export default __webpack_public_path__ + "static/bm-c64549610fb15420954330d9eac56727.svg";